import * as React from 'react';


import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader';
import { CharismaGoogleApi } from '../api/google/CharismaGoogleApi.tsx'
import CharismaStatsForm from './statsForm.tsx'

import Grid from '@mui/material/Grid'

import Typography from '@mui/material/Typography';




export default function CharismaSettings(props){
    
    const [getStats, setGetStats] = React.useState(false);

         
    function handleInitGoogle(){
        const lResponse = CharismaGoogleApi.Initialize();
        lResponse.then((value)=>{
            if(value["url"]){
                window.open(value["url"], "_blank");
            }
        }).catch((error)=>{
            
        })   
    }
    
    function cancelStats(){
        setGetStats(false);
    }
    
    return(
        <Box>
            <Grid container spacing={4}>
                <Grid item xs={12} sm={6}>
                    <Card>
                        <CardHeader
                            title={
                                <Box>
                                    <Typography>{"Connexion Google"}</Typography>  
                                </Box>
                            } 
                        />                
                        <CardContent>
                            <Button
                                onClick={()=>handleInitGoogle()}
                                variant='primary'
                            >
                            Initialisation
                            </Button>
                        </CardContent>
                    </Card>     
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Card>
                        <CardHeader
                            title={
                                <Box>
                                    <Typography>{"Bilans des Intervenants"}</Typography>  
                                </Box>
                            } 
                        />                
                        <CardContent>
                            <Button
                                onClick={()=>setGetStats(true)}
                                variant='primary'
                            >
                                Télécharger
                            </Button>
                        </CardContent>
                    </Card>             
    
                </Grid>
            </Grid>    
            {getStats ?
                <CharismaStatsForm
                    handleCancel={cancelStats}
                />:
                null
            }
        </Box>
          
    );
    
}